import { formatCoordinates, formatNumber, BrandMark } from '@sentinel/web-core';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { greetingKey } from '../greeting';
import { SCENE_CENTER, SCENE_SCALE_KM } from './scene-config';
import { ServiceStatus } from '../ServiceStatus';

interface Props {
  /** First name, once the user is known (after the password). */
  name?: string | undefined;
  subtitle: ReactNode;
}

/** Left side of the scene: brand, greeting that follows the step, scale, centre, services. */
export function SceneHud({ name, subtitle }: Props) {
  const { t } = useTranslation();
  const greeting = t(`accounts.hello.${greetingKey(new Date().getHours())}`);
  return (
    <section className="acc-hud" aria-labelledby="acc-hello">
      <div className="acc-brand">
        <BrandMark size={40} />
        <div>
          <div className="acc-brand-name">Progetto Sentinel</div>
          <div className="mlabel">{t('accounts.suite')}</div>
        </div>
      </div>
      <div className="acc-greet">
        <h1 className="acc-hello" id="acc-hello">
          {name === undefined
            ? t('accounts.hello.plain', { greeting })
            : t('accounts.hello.named', { greeting, name })}
        </h1>
        <p>{subtitle}</p>
      </div>
      <div className="acc-hud-foot">
        <div className="acc-scale-row">
          <div className="acc-scale" aria-hidden="true">
            <div className="bar">
              <i />
              <i />
              <i />
              <i />
            </div>
            <div className="ticks">
              <span>0</span>
              <span>{formatNumber(SCENE_SCALE_KM)} km</span>
            </div>
          </div>
          <div className="acc-coords">
            <span className="mlabel">{t('accounts.scene.center')}</span>
            {formatCoordinates(SCENE_CENTER.lng, SCENE_CENTER.lat)}
          </div>
        </div>
        <ServiceStatus />
      </div>
    </section>
  );
}
